import { Card } from "@mui/material";
import styles from "./UserChatMessage.module.css";
import { useTheme } from "@mui/material/styles";

interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    const theme = useTheme();
    const textBackgroundColor = theme.palette.primary.main;
    return (
        <div className={styles.container}>
            <Card sx={{ backgroundColor: textBackgroundColor, color: theme.palette.getContrastText(textBackgroundColor) }} className={styles.message}>
                {message}
            </Card>
        </div>
    );
};
